import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useLayoutEffect, useMemo, useRef, } from 'react';
import MuiToggleButton from '@material-ui/lab/ToggleButton';
import { combineClasses, removeClassName, styled, useForkRef, useThemeProps, } from '../../../foundation';
import { RcIcon } from '../../Icon';
import { withTooltip } from '../../Tooltip';
import { ToggleButtonStyle } from './styles';
import { RcToggleButtonClasses } from './utils';
var _RcToggleButton = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcToggleButton' });
    var classesProp = props.classes, children = props.children, size = props.size, variant = props.variant, symbol = props.symbol, IconProps = props.IconProps, rest = __rest(props, ["classes", "children", "size", "variant", "symbol", "IconProps"]);
    var innerRef = useRef(null);
    var buttonRef = useForkRef(ref, innerRef);
    var classes = useMemo(function () { return combineClasses(RcToggleButtonClasses, classesProp); }, [classesProp]);
    // * need remove not need Mui-selected for render correct
    useLayoutEffect(function () {
        removeClassName(innerRef, 'Mui-selected');
    });
    return (React.createElement(MuiToggleButton, __assign({}, rest, { ref: buttonRef, innerRef: buttonRef, classes: classes }),
        symbol && React.createElement(RcIcon, __assign({ symbol: symbol, size: "inherit" }, IconProps)),
        children));
});
var RcToggleButton = styled(withTooltip(_RcToggleButton))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ToggleButtonStyle);
RcToggleButton.defaultProps = {
    disableRipple: true,
    size: 'medium',
    variant: 'standard',
};
RcToggleButton.displayName = 'RcToggleButton';
export { RcToggleButton };
var templateObject_1;
